import BusinessProfileForm from '../components/BusinessProfileForm';
import { useNavigate, useParams } from 'react-router-dom';
import { Stack } from '@mui/material';
import { useGetBusinessProfileHandler } from '../dataHandlers/getBusinessProfileHandler';
import { useState, useEffect } from 'react';
import {useCreateBusinessProfileHandler} from "../dataHandlers/createBusinessProfileHandler";
import {usePermissions} from "../../../hooks/usePermissions";
import {useActionDeniedSnackbar} from "../../../hooks/useActionDeniedSnackbar";
import {UPDATE_BUSINESS_PROFILE} from "../../../constants/eInvoicePermissions";

export default function EditBusinessProfilePage() {
    const navigate = useNavigate();
    const { loading, hasEInvoicePermission } = usePermissions();
    const showActionDeniedSnackbar = useActionDeniedSnackbar();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { profile_id } = useParams();
    const onBusinessProfileCreated = (payload) => {
        navigate('/business-profiles');
    };

    const { businessProfile, isLoading: isLoadingData } = useGetBusinessProfileHandler(profile_id);
    const { onSubmit, error, isPending } = useCreateBusinessProfileHandler({ onSuccess: onBusinessProfileCreated });

    useEffect(() => {
        if (loading) {
            return;
        }
        if (!hasEInvoicePermission(UPDATE_BUSINESS_PROFILE)) {
            showActionDeniedSnackbar();
            navigate('/business-profiles', { replace: true });
        }
    }, [loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);

    // Reset isSubmitting when mutation completes
    useEffect(() => {
        if (!isPending && isSubmitting) {
            setIsSubmitting(false);
        }
    }, [isPending, isSubmitting]);

    const handleSubmit = async (payload) => {
        setIsSubmitting(true);
        try {
            await onSubmit(payload, true);
        } finally {
            setIsSubmitting(false);
        }
    };

    function handleCancel() {
        return navigate('/business-profiles');
    }

    if (isLoadingData || !businessProfile) {
        return null;
    }
    if (loading || !hasEInvoicePermission(UPDATE_BUSINESS_PROFILE)) {
        return null;
    }
    return (
        <Stack direction="column" sx={{ mt: '-2rem' }}>
            <BusinessProfileForm
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                initialData={businessProfile}
                edit={true}
                apiErrors={error}
                isLoading={isPending || isLoadingData || isSubmitting}
            ></BusinessProfileForm>
        </Stack>
    );
}
